import { render, staticRenderFns } from "./CarouselList.vue?vue&type=template&id=065432ac&scoped=true"
import script from "./CarouselList.vue?vue&type=script&lang=js"
export * from "./CarouselList.vue?vue&type=script&lang=js"
import style0 from "./CarouselList.vue?vue&type=style&index=0&id=065432ac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065432ac",
  null
  
)

export default component.exports